import useAppUser from 'hooks/useAppUser';
import { Container } from './Properties.styles';
import PropertiesContextProvider from './PropertiesContextProvider';
import PropertiesBody from './body/PropertiesBody';
import PropertiesFilterFormProvider from './filters/PropertiesFilterFormProvider';
import PropertiesHeader from './header/PropertiesHeader';
import { getPropertiesFilterLocalStorageKey } from './filters/PropertiesFilter.constants';

const PropertiesList = () => {
  const { userUid } = useAppUser();

  const localStorageKey = getPropertiesFilterLocalStorageKey(userUid as string);

  return (
    <PropertiesContextProvider localStorageKey={localStorageKey}>
      <Container>
        <PropertiesFilterFormProvider>
          <PropertiesHeader />
          <PropertiesBody />
        </PropertiesFilterFormProvider>
      </Container>
    </PropertiesContextProvider>
  );
};

export default PropertiesList;
